import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { belongsTo } from '@apexdesigner/schema-tools';

export const userTaskHistory = z
  .object({
    id: z.uuid().hidden().describe('Unique identifier'),

    eventType: z
      .enum([
        'Created',
        'Claimed',
        'Unclaimed',
        'Reassigned',
        'Completed',
        'Data Updated',
      ])
      .describe('What happened to the task'),

    data: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe('Additional details about what changed'),

    timestamp: z.coerce
      .date()
      .nullable()
      .optional()
      .describe('When this event occurred'),

    userTaskId: z.uuid().hidden().describe('Foreign key to UserTask'),

    userTask: belongsTo('UserTask'),
  })
  .describe('Records each action taken on a user task')
  .as('UserTaskHistory');

export { userTaskHistory as userTaskHistorySchema };
